import { InjectionToken } from '@angular/core';
import { Export } from '../models/Export';

/**
 * Injection token for providing export data to modal components.
 * This ensures the export data is available immediately when the component is created,
 * eliminating race conditions between modal creation and data assignment.
 */
export const MODAL_EXPORT_DATA = new InjectionToken<Export>('modal-export-data');